import { ExperimentData, generateExperiment } from './evidently-helper';

export enum FormVariant {
  old = 'old_form',
  new = 'new_form',
}

const experimentData: ExperimentData<FormVariant> = {
  FEATURE_NAME: 'contactForm',
  DEFAULT_VALUE: FormVariant.old,
  RESULT_PROPERTY_NAME: 'formSubmit',
  variant: null,
  experimentSubmitted: false,
  isLoadingExperiment: false,
  loadingPromise: null,
};

export const formExperiment = generateExperiment(experimentData);
